<template>
  <v-container fluid class="ProofDeliveryHistory">
    <PaginationController
      v-model="labels"
      getDataActionName="getApiLabels"
      :historyLimit="historyLimit"
      :select="hazmatWarehouseSite"
      haveStartDate
      isStartWithoutData
      :startDate="startDate"
      ref="paginate"
      :isApi="true"
      :maxDate="maxDate"
      :minDate="minDate"
      :actionPredicates="generatePredicate"
    >
      <template v-slot:afterDate>
        <v-flex>
          <v-layout align-center justify-end>
            <v-flex xs5>
              <v-switch :label="isMergePDF ? 'PDF' : 'ZIP'" v-model="isMergePDF"></v-switch>
            </v-flex>
            <v-flex xs6>
              <LoaderButton
                isSmall
                :buttonText="$t('downloadLabelsNum', { selectedLabelsLength: selectedLabels.length })"
                :promiseAwait="downloadSelectedLabelAndZip"
                :disabled="selectedLabels.length === 0"/>
            </v-flex>
            <v-flex justify-end>
              <v-btn small color="primary" @click="showExportLabelsPopup" :loading="exportLabelsPopup.loading">
                {{ $t('exportLabels') }}
              </v-btn>
            </v-flex>
            <v-flex justify-end>
              <v-btn small color="primary" @click="exportLabelsToExcel({ labels: selectedLabels })" :disabled="selectedLabels.length === 0">
                  {{ $t('exportSelectedLabels') }}({{ selectedLabels.length }})
                </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </template>
      <template v-slot:beforeMenu>
        <v-layout justify-start>
          <v-flex xs3 mr-1>
            <v-select
              :items="[
                { name: $t('status'), value: 'status' },
                { name: $t('requestId'), value: 'requestIds' },
                { name: $t('tracking'), value: 'trackings' },
              ]"
              item-value="value"
              item-text="name"
              v-model="searchMode"
              @change="
                e => {
                  searchText = ''
                  requestId = ''
                  selectText = ''
                  searchTracking = ''
                }
              "
              :label="$t('searchMode')"
            ></v-select>
          </v-flex>
          <v-flex xs4 pl-3 v-if="searchMode === 'requestIds'">
            <v-text-field
              :label="`${$t('requestId')}`"
              v-model="requestId"
              :hint="`${$t('requestId')} **${$t('enterToNext')}`"
              @change="changeBatchSearch(requestId, 'requestIds')"
              clearable
            />
          </v-flex>
          <v-flex xs4 pl-3 v-if="searchMode === 'trackings'">
            <v-text-field
              :label="`${$t('tracking')}`"
              v-model="searchTracking"
              @change="changeBatchSearch(searchTracking, 'searchTrackings')"
              :hint="`${$t('trackingNumber')} **${$t('enterToNext')}`"
              clearable
            />
          </v-flex>
          <template v-if="searchMode === 'status'">
            <v-flex xs2 >
            <v-autocomplete
              :items="labelStatusArray"
              item-value="value"
              item-text="name"
              v-model="selectText"
              :label="$t('labelStatus')"
            ></v-autocomplete>
          </v-flex>
          <!-- <v-flex xs4  ml-3>
            <v-text-field
              :hint="`${$t('memo')}/${$t('recipient')}/${$t('serviceType')}/${$t('tracking')}`"
              :label="$t('search')"
              v-model="searchText"
              clearable
            ></v-text-field>
          </v-flex> -->
          </template>
        </v-layout>
      </template>
      <template v-slot:dataTable>
        <v-data-table
          :headers="headers"
          :items="labels"
          hide-actions
          v-model="selectedLabels"
          item-key="orderId"
        >
          <template v-slot:items="props">
            <td class="checkbox-align-center" @click="props.item.url && props.item.status !== 'canceled' && (props.selected = !props.selected)">
              <v-layout>
                <v-checkbox
                  :disabled="!props.item.url || props.item.status === 'canceled'"
                  @click.stop="() => { props.selected = !props.selected }"
                  :value="props.selected"
                  primary
                  hide-details
                ></v-checkbox>
              </v-layout>
            </td>
                  <td class="text-xs-left">
                    <LabelDetailsWidget :shipmentLabel="props.item" :index="props.index" />
                  </td>
                  <td class="text-xs-left">
                    <LabelAddressWidget
                      :address="props.item.from"/>
                  </td>
                  <td class="text-xs-left">
                    <LabelAddressWidget
                      :address="props.item.to"/>
                  </td>
                  <td v-if="$store.getters.activeWarehouse" class="text-xs-left">
                    {{ organizationKeyToId.get(props.item.clientKey) }}
                  </td>
                  <td class="text-xs-left">
                    <v-layout>
                      {{ toDateYYYYMMDD(new Date(props.item.createTime)) }}
                    </v-layout>
                    <v-layout>
                      {{ props.item.shipDate }}
                    </v-layout>
                    <v-layout v-if="props.item.estimatedDelivery && props.item.estimatedDelivery !== 'N/A'" class="text-capitalize">
                      <v-flex v-if="typeof props.item.estimatedDelivery === 'string'">{{
                        toDateYYYYMMDD(new Date(props.item.estimatedDelivery))
                      }}</v-flex>
                      <v-flex v-else>{{ toDateYYYYMMDD(new Date(props.item.estimatedDelivery)) }}</v-flex>
                    </v-layout>
                  </td>
                  <td class="text-xs-left">
                    <LabelTrackingDetailWidget
                      v-if="props.item.status !== 'failed'"
                      :trackingNumber="props.item.trackingNumber"
                      :status="props.item.status"
                      :carrier="props.item.carrier"
                      :details="props.item.trackingDetails"
                      :isServer="true"
                      :trackStatus="props.item.trackStatus"
                      :trackDescription="props.item.trackDescription"
                    />
                    <div v-else-if="props.item.messages">
                      <p :key="messageItem.time" v-for="messageItem in props.item.messages" >
                        {{messageItem.message}}
                      </p>
                    </div>
                  </td>
                  <td class="text-xs-left">
                    <v-layout v-if="props.item.carrier">
                      <strong>{{ props.item.carrier }}</strong>
                    </v-layout>
                    <v-layout>
                      {{ props.item.serviceDescription }}
                    </v-layout>
                  </td>
                  <td :class="props.item.totalAmount ? 'text-xs-left fontRed' : (props.item.amount > 0 ? 'text-xs-left fontGreen' : 'text-xs-left fontRed')">
                    ${{ -props.item.totalAmount || props.item.amount || 0 }}
                  </td>
                  <td class="text-xs-left">
                    <span :style="{backgroundColor: isLabelOverOneWeek(props.item) ? 'yellow' : ''}">
                      {{ getStatusText(props.item) }}
                    </span>
                  </td>
                  <td class="text-xs-center">
                    <v-layout row justify-center>
                      <!-- <span v-if="props.item.status === 'pending' && env !== 'production'">
                        <v-tooltip top>
                          <template v-slot:activator="tooltip">
                            <div v-on="tooltip.on">
                              <LoaderButton
                                flat
                                :promiseAwait="getLabelStatus"
                                :promiseItem="props.item"
                                buttonIcon='refresh'
                              ></LoaderButton>
                            </div>
                          </template>
                          {{ $t('getStatus') }}
                        </v-tooltip>
                      </span> -->
                      <span v-if="props.item.url">
                        <v-tooltip top>
                          <template v-slot:activator="tooltip">
                            <div v-on="tooltip.on">
                              <v-btn
                                flat
                                icon
                                :color="props.item.isDownloaded ? 'success' : 'primary'"
                                @click.stop="downloadFile(props.item.url, props.item.orderKey, props.item._key)"
                                :disabled="!props.item.url || ['canceled', 'failed'].includes(props.item.status)"
                              ><v-icon>preview</v-icon></v-btn>
                            </div>
                          </template>
                          {{ $t('openLabel') }}
                        </v-tooltip>
                      </span>
                      <span>
                        <v-menu offset-y>
                          <template v-if="props.item.carrier !== 'USPS' && (props.item.status === 'created' || props.item.status === 'pending')" v-slot:activator="{ on }">
                            <v-tooltip top>
                              <template v-slot:activator="tooltip">
                                <div v-on="tooltip.on">
                                  <v-btn @click.stop="on.click" dark icon flat color="primary">
                                    <v-icon>build</v-icon>
                                  </v-btn>
                                </div>
                              </template>
                              {{ $t('more') }}
                            </v-tooltip>
                          </template>
                          <v-list>
                            <!-- <v-list-tile
                              v-if="props.item.requestId === props.item._key"
                              class="list-tile-center"
                            >
                              <LoaderButton
                                flat
                                :buttonText="$t('copy')"
                                :promiseAwait="copyLabel"
                                :promiseItem="props.item"
                              ></LoaderButton>
                            </v-list-tile> -->
                            <v-list-tile
                              class="list-tile-center"
                            >
                              <v-tooltip top>
                                <template v-slot:activator="tooltip">
                                  <div v-on="tooltip.on">
                                    <LoaderButton
                                      flat
                                      :buttonText="$t('cancel')"
                                      :promiseAwait="cancelLabel"
                                      :disabled="visibleBetaFeatures.includes('cancelLabelByDownloaded') && props.item.isDownloaded"
                                      :promiseItem="props.item"
                                    ></LoaderButton>
                                  </div>
                                </template>
                                {{ props.item.isDownloaded ? $t('contactToCancelLabel') : $t('cancel') }}
                              </v-tooltip>
                            </v-list-tile>
                            <!-- <v-list-tile
                              class="list-tile-center"
                              v-if="(props.item.carrier && props.item.carrier.toUpperCase() === 'FEDEX' && props.item.isProofDelivery)"
                            >
                              <LoaderButton
                                flat
                                :buttonText="$t('updateProofDelivery')"
                                :promiseAwait="updateProofDelivery"
                                :promiseItem="props.item"
                              ></LoaderButton>
                            </v-list-tile> -->
                          </v-list>
                        </v-menu>
                      </span>
                    </v-layout>
                  </td>
          </template>
        </v-data-table>
      </template>
      <!-- <template v-slot:beforeMenu>
      </template> -->
    </PaginationController>

    <FormSubmitPopup
      :title="$t('exportLabels')"
      v-model="exportLabelsPopup.show"
      :rightMethod="exportLabels"
      :rightButtonText="$t('export')"
      @popupClose="exportLabelsPopup.show = false"
      small
      hasAlert
    >
      <template v-slot:input>
        <v-layout>
          <v-flex>
            <DatePicker
              v-model="exportLabelsPopup.dates"
              :label="$t('date')"
              range
              :max="dateMax"
              :min="dateMin"
            />
          </v-flex>
        </v-layout>
      </template>
    </FormSubmitPopup>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import PaginationController from './PaginationController'
import LabelDetailsWidget from './LabelDetailsWidget'
import LabelAddressWidget from './LabelAddressWidget'
import LabelTrackingDetailWidget from './LabelTrackingDetailWidget'
import FormSubmitPopup from './FormSubmitPopup'
import DatePicker from './DatePicker.vue'
import LoaderButton from './LoaderButton'
import { format } from 'date-fns'
import { checkRules, timeTools, measurementTools, downloadLabelFile } from '../utils/tools'

export default {
  name: 'ApiLabel',
  components: {
    PaginationController,
    LabelDetailsWidget,
    LabelAddressWidget,
    LabelTrackingDetailWidget,
    FormSubmitPopup,
    LoaderButton,
    DatePicker
  },
  mixins: [checkRules, timeTools, measurementTools],
  data () {
    const now = new Date()
    return {
      searchMode: 'status',
      selectedLabels: [],
      hazmatWarehouseSite: '',
      labels: [],
      historyLimit: 20,
      showDatePick: false,
      op950Modal: {
        show: false,
        loading: false,
        closeDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        hazmatWarehouseSite: ''
      },
      isMergePDF: false,
      exportLabelsPopup: {
        show: false,
        dates: [new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000), now],
        loading: false
      },
      startDate: new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000),
      selectText: '',
      searchText: '',
      maxDate: now.toISOString(),
      minDate: new Date(now.getTime() - 31 * 24 * 60 * 60 * 1000).toISOString(),
      searchTracking: '',
      requestId: ''
    }
  },
  computed: {
    ...mapGetters([
      'hazmatSites',
      'activeWarehouse',
      'activeOrganization',
      'visibleBetaFeatures'
    ]),
    generatePredicate () {
      const mode = this.searchMode
      // const { selectText, searchText, requestIds = [], searchTrackings = [] } = this
      const predicate = []
      if (mode === 'requestIds' && this.requestId) {
        predicate.push({
          field: 'requestId',
          compare: 'in',
          value: this.requestId
        })
      }
      if (mode === 'trackings' && this.searchTracking) {
        predicate.push({
          field: `trackingNumber`,
          compare: 'in',
          value: this.searchTracking
        })
      }
      if (mode === 'status' && this.selectText) {
        if (this.activeOrganization) {
          predicate.push({
            field: `status`,
            compare: '==',
            value: this.selectText
          })
        }
      }
      return predicate
    },
    dateMin () {
      const [startDate, endDate] = this.exportLabelsPopup.dates
      if (startDate && endDate) return undefined
      if (startDate) {
        const monthTime = 31 * 60 * 60 * 24 * 1000
        const time = startDate.getTime() - monthTime
        return new Date(time).toISOString()
      }
      return undefined
    },
    dateMax () {
      const [startDate, endDate] = this.exportLabelsPopup.dates
      const now = new Date()
      if (startDate && endDate) return now.toISOString()
      if (startDate) {
        const monthTime = 31 * 60 * 60 * 24 * 1000
        const time = startDate.getTime() + monthTime
        return now.getTime() < time ? now.toISOString() : new Date(time).toISOString()
      }
      return now.toISOString()
    },
    labelStatusArray () {
      const array = [
        { name: `-- ${this.$t('all')} --`, value: '' },
        { name: this.$t('pending'), value: 'pending' },
        { name: this.$t('created'), value: 'created' },
        { name: this.$t('invoiced'), value: 'invoiced' },
        // { name: this.$t('inTransit'), value: 'in transit' },
        // { name: this.$t('delivered'), value: 'delivered' },
        { name: this.$t('canceled'), value: 'canceled' }
      ]
      return array
    },
    headers () {
      const headers = [
        { text: this.$t('details'), value: 'signature', align: 'left', sortable: false, width: '20%' },
        { text: this.$t('from'), value: 'from', align: 'left', sortable: false },
        { text: this.$t('to'), value: 'to', align: 'left', sortable: false },
        { text: this.$t('create/ship/estDeliveryDate'), value: 'createTime', align: 'left', sortable: false },
        { text: this.$t('tracking/info'), value: 'trackingNumber', align: 'left', sortable: false },
        { text: this.$t('service'), value: 'shippingService', align: 'left', sortable: false },
        { text: this.$t('amount'), value: 'amount', align: 'left', sortable: false },
        { text: this.$t('status'), value: 'status', align: 'left', sortable: false },
        { text: this.$t('actions'), value: '', align: 'center', sortable: false }
      ]
      headers.unshift({ text: '#', value: '', align: 'center', sortable: false })
      return headers
    },
    hazmatSitesOptions () {
      return this.hazmatSites.map(site => ({
        text: site.siteName,
        value: site.key
      }))
    }
  },
  filters: {
    formatDate (date, formatter = 'yyyy/MM/dd') {
      if (!date) return ''
      return format(date, formatter)
    }
  },
  methods: {
    getStatusText (item) {
      const trackingStatuses = ['ready', 'in transit', 'delivered']
      if (trackingStatuses.includes(item.status) && !!item.trackStatus) {
        return item.trackStatus
      }
      return item.status || 'ready'
    },
    isLabelOverOneWeek (item) {
      const today = new Date()
      const timeDiff = Math.abs(today.getTime() - new Date(item.createTime)?.getTime())
      const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24))
      return daysDiff > 7 && (item.status === 'ready' || item.status === 'in transit')
    },
    async downloadFile (url, orderKey, key) {
      if (
        this.$store.getters.tenantLimitedInfo &&
        this.$store.getters.tenantLimitedInfo.isRenameLabelByOrderKey &&
        orderKey
      ) {
        await downloadLabelFile(url, orderKey ? `${orderKey.split('-').slice(1).join('-')}.pdf` : undefined)
      } else {
        window.open(url)
      }
      return this.$store.dispatch('updateLabelDownloadStatus', {key: key})
        .then(() => {
          const idx = this.labels.findIndex(item => item._key === key)
          if (idx === -1) return
          this.$set(this.labels, idx, {...this.labels[idx], isDownloaded: true})
        })
    },
    async exportLabels () {
      try {
        this.exportLabelsPopup.loading = true
        this.exportLabelsPopup.show = false
        const [startDate, endDate] = this.exportLabelsPopup.dates
        const labels = []
        let startKey = null
        do {
          const result = await this.getLabels(startDate, endDate, startKey)
          startKey = result.data.startKey
          labels.push(...result.data.data)
        } while (startKey)
        this.exportLabelsPopup.loading = false
        return this.exportLabelsToExcel(
          {
            labels: labels.map(doc => ({ ...doc, createTime: new Date(doc.createTime) })),
            startDate,
            endDate
          }
        )
      } catch (err) {
        alert(err.message)
        this.exportLabelsPopup.loading = false
      }
    },
    async getLabels (startDate, endDate, startKey) {
      const result = await this.$store.dispatch('getApiLabels', {
        startDate,
        endDate,
        startAfter: startKey
      })
      return result
    },
    exportLabelsToExcel (data) {
      return this.$store.dispatch('exportLabelsToExcel', data)
    },
    downloadSelectedLabelAndZip () {
      this.selectedLabels.sort((a, b) => {
        return a._key < b._key ? -1 : 1
      })
      return this.$store.dispatch('downloadSelectedLabels', {
        labels: this.selectedLabels.filter(item => item.url && item.status !== 'canceled'),
        isMergePDF: this.isMergePDF
      })
    },
    showExportLabelsPopup () {
      this.exportLabelsPopup.show = true
    },
    changeBatchSearch (arr = [], fieldName) {
      // arr = arr.reduce((resArr, currItem) => {
      //   return resArr.concat(splitKeyword(currItem))
      // }, [])
      // this.$set(this, fieldName, arr.filter(item => item))
    },
    async cancelLabel (label) {
      if (!confirm(this.$t('confirmCancel', { name: 'label' }))) return Promise.resolve()
      try {
        this.isLoading = true
        await this.$store.dispatch('canceApilLabel', label)
        this.labels
          .forEach(item => {
            if (item.requestId === label.requestId) {
              this.$set(item, 'status', 'canceled')
            }
          })
        this.isLoading = false
      } catch (err) {
        alert(err.message)
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
  .fontRed {
    color: red;
  }

  .fontGreen {
    color: green;
  }
</style>



// WEBPACK FOOTER //
// src/components/ApiLabel.vue